<template>
    <FKBreadCrumb :page="version?.revision_number" >
        <FKBreadCrumbItem :page="$t('page.consents')" :to="`/consents`"/>
        <FKBreadCrumbItem :page="$t('page.consent')" :to="`/consent/${consent?.id}`"/>
    </FKBreadCrumb>
    <ConsentVersionsInfo />
</template>
  
<script lang="ts">
import { defineComponent } from "vue";

import ConsentVersionsInfo from "@/components/FK/Consents/ConsentVersionInfo.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import { Consent, ConsentVersion } from "@/utils/models/consent.model";

export default defineComponent({
    name: "ConsentsPage",
    components: {
        FKBreadCrumb,
        FKBreadCrumbItem,
        ConsentVersionsInfo,
    },
    data() {
        console.log(this.$route.meta);
        return {
            consent: this.$route.meta.consent as Consent | undefined,
            version: this.$route.meta.consent_version as ConsentVersion | undefined,
        }
    },
});
</script>